import styled, { keyframes } from 'styled-components';

const animationIn = keyframes`
  0% { 
    top: -50px; 
    opacity: 0; ß
  }
  
  100% {
    top: 0px; 
    opacity: 1;
  }
`;

const Wrapper = styled.div`
  animation: ${animationIn} 0.7s 0.4s forwards;
  font-size: 10px;
  opacity: 0;
  position: relative;
`;

const Title = styled.h1`
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 2.4em;
  padding-left: 32px;
`;

export { Wrapper, Title };
